import { ActionIcon, Tooltip } from '@mantine/core'

import { toast } from 'src/components/Overlays/Toast/Toast'
import IconCopy from 'src/icons/IconCopy'

interface CopyableIdProps {
  value: string
  label?: string
}

const CopyableId = ({ value, label = 'ID' }: CopyableIdProps) => {
  const handleCopy = (event: React.MouseEvent) => {
    event.stopPropagation()
    navigator?.clipboard?.writeText?.(value)
    toast(`${label} copied to clipboard`, 'success')
  }

  return (
    <Tooltip label={value} withArrow>
      <ActionIcon
        variant="subtle"
        size={18}
        color="gray"
        onClick={handleCopy}
      >
        <IconCopy className="h-3.5 w-3.5 fill-none stroke-doubleNickel-gray-500" />
      </ActionIcon>
    </Tooltip>
  )
}

export default CopyableId
